import { useStorage } from "../layers/Storage"

export const useToday = () => {
    const [{ date }] = useStorage()
    return date && !isNaN(date) ? date : new Date()
}